import { render, staticRenderFns } from "./OrderNow.vue?vue&type=template&id=bc60e5ee"
import script from "./OrderNow.vue?vue&type=script&lang=js"
export * from "./OrderNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports